import { App, Button, Dropdown, Menu } from "antd";
import CustomTable from "../table";
import LoyaltyCouponsModal from "./loyaltyCouponModal";
import { useEffect, useState } from "react";
import config from "../../config";
import { useSelector } from "react-redux";
import { EllipsisOutlined } from "@ant-design/icons";

const LoyaltyCoupons = () => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const shopId = useSelector((state) => state.shopDetails.shopId);
  const [couponList, setCouponList] = useState([]);
  const { productList } = useSelector((state) => state.products);
  const [mode, setMode] = useState("add");
  const [initialValues, setInitialValues] = useState({});
  const { message } = App.useApp();

  const handleEdit = (formData) => {
    console.log("formData", formData);
    setOpen(true);
    setMode("edit");
    setInitialValues(formData);
  };

  const handleDelete = (couponId) => {
    couponDeleteMutation(couponId);
  };

  const menu = (rowData) => {
    return [
      {
        key: 1,
        label: "Edit",
        style: {
          width: "150px",
        },
        onClick: () => handleEdit(rowData),
      },
      {
        key: 2,
        label: "Delete",
        style: {
          width: "150px",
        },
        onClick: () => handleDelete(rowData.couponId),
      },
    ];
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "couponDetails",
      key: "couponDetails",
    },
    {
      title: "Reward Type",
      dataIndex: "rewardType",
      key: "rewardType",
      render: (data) => {
        return (
          <div>
            {data?.name ? (data?.name === "product" ? "Product" : "Cash") : "-"}
          </div>
        );
      },
    },
    {
      title: "Reward Value",
      dataIndex: "rewardType",
      key: "rewardType",

      render: (data) => {
        let product = {};
        if (data?.name === "product") {
          product = productList.find(
            (product) => product.productId === data.value
          );
        }
        return (
          <div>
            {data?.name
              ? data?.name === "product"
                ? product?.productName || "Product is deleted"
                : data?.value
              : "-"}
          </div>
        );
      },
    },
    {
      title: "Required Loyalty Points",
      dataIndex: "minLoyaltyPointsReq",
      key: "minLoyaltyPointsReq",
    },
    {
      title: "Action",
      key: "action",
      render: (rowData) => {
        return (
          <Dropdown
            getPopupContainer={(el) => el.parentNode}
            menu={{
              items: menu(rowData),
            }}
            placement="left"
            arrow
          >
            <EllipsisOutlined
              style={{
                fontSize: "2rem",
                transform: "rotate(90deg)",
                cursor: "pointer",
                padding: "1rem",
              }}
            />
          </Dropdown>
        );
      },
    },
  ];

  const couponDeleteMutation = async (couponId) => {
    setLoading(true);
    try {
      const response = await fetch(config.newApiGateway + "/loyalty/loyalty", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-api-key": config.newApiKey,
        },
        body: JSON.stringify({
          action: "deleteCoupon",
          couponId: couponId,
          shopId: shopId,
        }),
      });
      const data = await response.json();
      if (data.status === "SUCCESS") {
        fetchCoupon(shopId);
        message.success(data.message);
      }
      console.log("data", data);
    } catch (error) {
      console.log("error", error);
    } finally {
      setLoading(false);
    }
  };

  async function fetchCoupon(shopId) {
    try {
      const response = await fetch(config.newApiGateway + "/loyalty/loyalty", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-api-key": config.newApiKey,
        },
        body: JSON.stringify({
          action: "fetchLoyaltyCoupon",
          shopId: shopId,
        }),
      });
      const data = await response.json();

      if (Array.isArray(data)) {
        setCouponList(data);
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    (async () => {
      if (shopId) {
        await fetchCoupon(shopId);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shopId]);

  return (
    <>
      <CustomTable
        loading={loading}
        columns={columns}
        data={couponList}
        title={"Loyalty Coupons"}
        extraAction={
          <Button
            type="primary"
            onClick={() => {
              setOpen(true);
              setMode("add");
            }}
          >
            Add Coupon
          </Button>
        }
      />
      <LoyaltyCouponsModal
        mode={mode}
        initialValues={initialValues}
        open={open}
        onClose={() => {
          setOpen(false);
          setInitialValues({});
        }}
        refetch={() => {
          fetchCoupon(shopId);
        }}
        onCheckCouponAlreadyExist={(v, editCouponId) => {
          const isExist = couponList
            .filter((i) => i.couponId !== editCouponId)
            .find((i) => i.couponDetails.toLowerCase() === v.toLowerCase());
          return isExist;
        }}
        key={mode}
      />
    </>
  );
};

export default LoyaltyCoupons;
